module.exports = __webpack_public_path__ + "static/media/CT_2019_30447A_pdf.7ede4ea9.pdf";